import { render, staticRenderFns } from "./DashboardWhatsapp.vue?vue&type=template&id=bc7c9704&scoped=true&"
import script from "./DashboardWhatsapp.vue?vue&type=script&lang=js&"
export * from "./DashboardWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWhatsapp.vue?vue&type=style&index=0&id=bc7c9704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7c9704",
  null
  
)

export default component.exports